
import NewsArticle from './NewsArticle.vue'
import Tables from '@/components/common/TablesDb.vue'
import InputText from '@/components/common/InputText.vue'
import ConfirmDlg from '@/components/common/ConfirmDlg.vue'

import { defineComponent, ref, computed, markRaw, watch } from 'vue'
import { useApi } from '@/lib/api'
import { useRoute } from 'vue-router'
import { useAppViewedList } from '@/lib/common'

const actions = markRaw({
  template: `<span><ConfirmDlg ref="dlg" title="Želite izbrisati podatek?" @confirm="del" /><router-link :to="{params: {id: data.id }}" tag="a" class="text-bold">Preglej </router-link> <span v-if="data.title !=='Noga'">| <a class="text-bold" @click.prevent="$refs.dlg.open(data.id)" href>Briši</a></span></span>`,
  components: { ConfirmDlg },
  props: {
    data: {}
  },
  methods: {
    del(c: boolean) {
      if (c) {
        this.$parent.$parent.del(this.$refs.dlg.tag)
      }
    }
  }
})

export default defineComponent({
  components: { Tables, NewsArticle, InputText },
  setup() {
    const { recordExists } = useAppViewedList()
    const _api = useApi()
    const _route = useRoute()
    const cols = ref([
      { field: 'id', caption: '#', dbField: 'id', hidden: true },
      { field: 'title', caption: 'Naslov', dbField: 'naslov' },
      { field: 'date', caption: 'Datum', format: { type: 'date', format: 'DD.MM.YYYY' }, dbField: 'datum' },
      { field: 'active', caption: 'Aktivnost', format: { type: 'yesno' }, dbField: 'aktiven' },
      { field: 'new', caption: 'Novo', format: { type: 'yesno' }, dbField: 'nov' },
      { field: 'dateCreate', caption: 'Kreiran', format: { type: 'date', format: 'DD.MM.YYYY HH:mm' }, dbField: 'date_create', class: 'nowrap' },
      { field: 'dateUpdate', caption: 'Posodobljen', format: { type: 'date', format: 'DD.MM.YYYY HH:mm' }, dbField: 'date_update', class: 'nowrap' },
      { caption: 'Akcija', component: actions, class: 'nowrap actions' }
    ])
    const data = ref([])
    const filter = ref({ pagerPage: 1, pagerPageSize: 20, pagerSort: 'id desc' })
    const hasId = computed(() => _route.params.id)

    const del = async (id: any) => {
      await _api.post<any>('adminNewsDelete?id=' + id, true)
      getData()
    }

    const getData = async (e?: any, f?: any) => {
      if (!hasId.value) {
        if (e) {
          filter.value.pagerPage = e.page
          filter.value.pagerSort = e.sort ? e.sort : 'id desc'
        } else if (filter.value.pagerPage > 1) {
          if (f) {
            filter.value.pagerPage = 1
          }
          return
        }
        const res = await _api.post<any>('adminNewsList', filter.value, true)
        data.value = res.data
      }
    }

    watch(hasId, () => getData())

    getData()

    return { cols, data, filter, getData, hasId, del, recordExists }
  }
})
